import { inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper, typeof as _typeof } from '../../_virtual/_rollupPluginBabelHelpers.mjs';
import { __rest } from '/Users/gimboseog/development/moim-frontend/node_modules/tslib/tslib.es6.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { ShavedTextWrapper, WebkitShavedText, SingleShavedText } from './styled.mjs';
import * as React from 'react';
import { useInView } from 'react-intersection-observer';
import shave from 'shave';
import './v2/styled.mjs';

var SPACES_REGEXP = /\s/;
var TextElement = /*#__PURE__*/React.forwardRef(function (_ref, passRef) {
  var children = _ref.children;
  var _useInView = useInView({
      triggerOnce: true
    }),
    ref = _useInView.ref,
    entry = _useInView.entry;
  React.useImperativeHandle(passRef, function () {
    return {
      entry: entry
    };
  });
  return jsx("span", {
    ref: ref,
    style: {
      verticalAlign: "top",
      wordBreak: "break-all"
    },
    children: children
  });
});
var ShavedText = /*#__PURE__*/function (_React$PureComponent) {
  function ShavedText() {
    var _this;
    _classCallCheck(this, ShavedText);
    _this = _callSuper(this, ShavedText, arguments);
    _this.state = {
      shaved: false,
      visibleEndFix: false,
      lineClamp: 0,
      shavedByLibrary: false,
      component: ShavedTextWrapper
    };
    _this.textElement = /*#__PURE__*/React.createRef();
    _this.textElementOffsetHeight = 0;
    _this.onShaved = function () {
      var _a, _b, _c, _d, _e;
      var flag = false;
      if (!_this.state.shavedByLibrary) {
        flag = false;
      }
      var textElement = (_b = (_a = _this.textElement.current) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.target;
      if (textElement) {
        flag = ((_c = textElement.firstElementChild) === null || _c === void 0 ? void 0 : _c.classList[0]) === "js-shave-char";
      }
      _this.setState({
        shaved: flag
      });
      (_e = (_d = _this.props).onShaved) === null || _e === void 0 ? void 0 : _e.call(_d, flag);
    };
    _this.shaveTextFromLibrary = function () {
      var _a, _b, _c;
      var textElement = (_b = (_a = _this.textElement.current) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.target;
      if (!textElement) {
        return;
      }
      _this.setState({
        visibleEndFix: false,
        shavedByLibrary: true
      });
      var _this$props = _this.props,
        shaveHeight = _this$props.shaveHeight,
        _this$props$line = _this$props.line,
        line = _this$props$line === void 0 ? 1 : _this$props$line,
        ellipsisText = _this$props.ellipsisText;
      var text = (_c = textElement.textContent) !== null && _c !== void 0 ? _c : "";
      var offsetHeight = _this.textElementOffsetHeight;
      var spaces = !SPACES_REGEXP.test(text.trim());
      var shaveHeightCalc = shaveHeight || Math.round(_this.getTextElementLineHeight()) * line;
      var adjustmentShaveHeight = shaveHeightCalc + 2;
      shave(textElement, adjustmentShaveHeight, {
        character: ellipsisText,
        spaces: spaces
      });
      // re-check
      if (offsetHeight > adjustmentShaveHeight) {
        shave(textElement, adjustmentShaveHeight, {
          character: ellipsisText,
          spaces: false
        });
      }
      if (!_this.state.visibleEndFix) {
        _this.setState({
          visibleEndFix: true
        });
      }
    };
    _this.getTextElementLineHeight = function () {
      var _a, _b;
      var textElement = (_b = (_a = _this.textElement.current) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.target;
      if (textElement) {
        return requestAnimationFrame(function () {
          var styles = window.getComputedStyle(textElement);
          var fontSize = parseFloat(styles.lineHeight);
          if (isNaN(fontSize)) {
            fontSize = parseFloat(styles.fontSize);
            if (isNaN(fontSize)) {
              return 0;
            }
          }
          return fontSize;
        });
      }
      return 0;
    };
    _this.shaveText = function () {
      var isWebkitBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && (typeof document === "undefined" ? "undefined" : _typeof(document)) !== undefined && "webkitCancelAnimationFrame" in document;
      if (_this.props.endFix || _this.props.ellipsisText) {
        _this.shaveTextFromLibrary();
      } else if (_this.textElement.current) {
        var _this$props2 = _this.props,
          shaveHeight = _this$props2.shaveHeight,
          _this$props2$line = _this$props2.line,
          line = _this$props2$line === void 0 ? 1 : _this$props2$line;
        var lineClamp = shaveHeight ? Math.floor(shaveHeight / _this.getTextElementLineHeight()) : line;
        var isMultiLimeClamp = lineClamp > 1;
        if (_this.props.forceShaveByLibrary || !isWebkitBrowser && isMultiLimeClamp) {
          _this.shaveTextFromLibrary();
        } else {
          _this.setState({
            shavedByLibrary: false,
            lineClamp: lineClamp,
            component: isMultiLimeClamp ? WebkitShavedText : SingleShavedText
          });
        }
      }
    };
    _this.updateShaveText = function () {
      if ((typeof window === "undefined" ? "undefined" : _typeof(window)) !== undefined && !_this.state.shaved) {
        _this.shaveText();
      }
    };
    _this.renderEndFixPreWrap = function () {
      var styles = {
        marginRight: _this.props.endFixPreWrapMargin ? _this.props.endFixPreWrapMargin : 15
      };
      return jsx("span", {
        style: styles,
        children: _this.props.endFix
      });
    };
    return _this;
  }
  _inherits(ShavedText, _React$PureComponent);
  return _createClass(ShavedText, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateShaveText();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _a, _b, _c;
      if (this.textElement.current) {
        this.textElementOffsetHeight = (_c = (_b = (_a = this.textElement.current) === null || _a === void 0 ? void 0 : _a.entry) === null || _b === void 0 ? void 0 : _b.boundingClientRect.height) !== null && _c !== void 0 ? _c : 0;
      }
      var isDiffText = typeof this.props.value === "string" && prevProps.value && prevProps.value !== this.props.value;
      if (isDiffText || prevProps.shaveHeight !== this.props.shaveHeight || prevProps.line !== this.props.line) {
        this.updateShaveText();
      }
      this.onShaved();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
        value = _a.value;
        _a.shaveHeight;
        _a.ellipsisText;
        _a.endFixPreWrapMargin;
        var endFix = _a.endFix,
        wrapperStyle = _a.wrapperStyle,
        props = __rest(_a, ["value", "shaveHeight", "ellipsisText", "endFixPreWrapMargin", "endFix", "wrapperStyle"]);
      var _this$state = this.state,
        component = _this$state.component,
        visibleEndFix = _this$state.visibleEndFix;
      return /*#__PURE__*/React.createElement(component, Object.assign(Object.assign({}, props), {
        line: this.state.lineClamp,
        overrideStyle: wrapperStyle
      }), jsxs(Fragment, {
        children: [!visibleEndFix && endFix ? this.renderEndFixPreWrap() : null, jsx(TextElement, {
          ref: this.textElement,
          children: value
        }), visibleEndFix && endFix ? endFix : null]
      }));
    }
  }]);
}(React.PureComponent);

export { ShavedText };
